// Соцсети — укажи свои ссылки:
export const INSTAGRAM_URL = 'https://instagram.com';
export const TELEGRAM_URL = 'https://t.me';

export const HERO_VIDEO_SRC = '/assets/main/hero.mp4';

// Положи фото в public/assets/main/ и укажи путь к файлу:
export const ABOUT_PHOTO_SRC = '/assets/main/main.jpeg';

// До/После — блок ретуши (public/assets/slides/)
export const PIC_SLIDE_RETOUCH = {
  before: '/assets/slides/retouch-before.jpg',
  after: '/assets/slides/retouch-after.jpg',
};

// Два больших слайдера внизу — по 2 фото на каждый (public/assets/slides/)
export const PIC_SLIDE_GALLERY = [
  {
    before: '/assets/slides/gallery-1-before.jpg',
    after: '/assets/slides/gallery-1-after.jpg',
  },
  {
    before: '/assets/slides/gallery-2-before.jpg',
    after: '/assets/slides/gallery-2-after.jpg',
  },
  {
    before: '/assets/slides/gallery-2-before.jpg',
    after: '/assets/slides/gallery-2-after.jpg',
  },
  {
    before: '/assets/slides/gallery-2-before.jpg',
    after: '/assets/slides/gallery-2-after.jpg',
  },
];
